import Vue from 'vue'
import axios from 'axios'
import ElementUI from 'element-ui'
import 'styles/iconfont.css'
import 'styles/index.css'
import 'styles/rem.js'
import './isMobile.js'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'vue-awesome-swiper/node_modules/swiper/dist/css/swiper.css'
import VueParticles from 'vue-particles'
import md5 from 'js-md5'
import { Message, confirm, loading } from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import VueAMap from 'vue-amap'
import 'babel-polyfill'

axios.defaults.withCredentials = true
Vue.prototype.$axios = axios
Vue.prototype.$md5 = md5
Vue.prototype.$Message = Message
Vue.prototype.$confirm = confirm
Vue.prototype.$loading = loading
Vue.use(VueAwesomeSwiper)
Vue.use(VueParticles)
Vue.use(ElementUI)
Vue.use(VueAMap)
VueAMap.initAMapApiLoader({
  key: 'ee69817529659ec9420f072183621d26',
  plugin: ['AMap.Container', 'AMap.Parameters']
})

// 在请求头中加token
axios.interceptors.request.use(
  config => {
    var login // 必须登录接口添加 login = 1 参数
    var type // 添加类型，1 为 供应链（设置跳转登录页）
    var token
    var Jump // 设置跳转登录页
    if (config.method === 'get') {
      login = config.login
      type = config.LoginType
    } else {
      login = config.data.login
      type = config.data.LoginType
    }
    if (type === 1) {
      token = sessionStorage.getItem('GylToken')
      Jump = 'gylLogin.html'
    } else if (type === 2) {
      token = sessionStorage.getItem('GiftToken')
      Jump = 'gift.html'
    }
    if (!config.headers.hasOwnProperty('token') && token) {
      config.headers.Authorization = token
    }
    config.headers.JumpT = Jump
    if (login === 1) {
      if (!token || token === '') {
        // let m = Message({
        //   showClose: true,
        //   message: '请先登录',
        //   type: 'warning'
        // })
        setTimeout(function () {
          location.href = Jump
          config.headers.loginT = 1
        }, 2000)
      }
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

axios.interceptors.response.use(res => {
  if (res.config.responseType !== 'blob') {
    if (res.data.code === 444) {
      let m = Message({
        showClose: true,
        message: '登录失效， 请重新登录',
        type: 'warning'
      })
      setTimeout(function () {
        m.close
        location.href = res.config.headers.JumpT
      }, 2000)
    } else if (res.data.code !== 200) {
      Message({
        message: res.data.message,
        type: 'warning'
      })
    } else {
      return res
    }
  } else {
    return res
  }
})

Vue.prototype.resetSetItem = function (key, newVal) {
  // if (key === 'GiftIslogin') {
    // 创建一个StorageEvent事件
    var newStorageEvent = document.createEvent('StorageEvent');
    const storage = {
      setItem: function (k, val) {
        sessionStorage.setItem(k, val);
        // 初始化创建的事件
        newStorageEvent.initStorageEvent('setItem', false, false, k, null, val, null, null);
        // 派发对象
        window.dispatchEvent(newStorageEvent)
      }
    }
    return storage.setItem(key, newVal);
  // }
}


// WEBPACK FOOTER //
// ./src/util/appUtil.js